import React, { useState } from "react";

import './Navbar.css'
import {Link} from 'react-router-dom'



const Navbar = () => {

 
 return (<>
  <header >
    <Link to='/'>
    
      <div className='logo'>
      {/* <span className='purple'>Spell</span> */}
       <h1>Encryptor</h1>
       </div>
    
    </Link>
   <nav >
   <ul className='nav_links'>
      
      <li className="laptop-link"><a href='/about'>About</a></li>
      
      
   </ul>
   </nav>
   </header>



  
   </>
 )
}

export default Navbar